import React from 'react';

export const GreenIconSVG = () => {

    return (
        <div className="svg-wrapper">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="Icons">
                    <path
                        id="Vector"
                        d="M4 23V21H20V23H4ZM4 3V1H20V3H4ZM12 13C12.8333 13 13.5417 12.7083 14.125 12.125C14.7083 11.5417 15 10.8333 15 10C15 9.16667 14.7083 8.45833 14.125 7.875C13.5417 7.29167 12.8333 7 12 7C11.1667 7 10.4583 7.29167 9.875 7.875C9.29167 8.45833 9 9.16667 9 10C9 10.8333 9.29167 11.5417 9.875 12.125C10.4583 12.7083 11.1667 13 12 13ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM5.75 18H18.25C17.5 17.0667 16.5917 16.3333 15.525 15.8C14.4583 15.2667 13.2833 15 12 15C10.7167 15 9.54167 15.2667 8.475 15.8C7.40833 16.3333 6.5 17.0667 5.75 18Z"
                        fill="#27AE60"
                    />
                </g>
            </svg>
        </div>
    );
};

export const GreenDocIconSVG = () => {

    return (
        <div className="svg-wrapper">
            <svg 
                width="24"
                height="24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 384 512">
                <path 
                    d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 288c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128z" 
                    fill="#27AE60"
                />
            </svg>
        </div>
    );
};

export const GreenDollarIconSVG = () => {

    return (
        <div className="svg-wrapper">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                    d="M11.1 19H12.85V17.75C13.6833 17.6 14.4 17.275 15 16.775C15.6 16.275 15.9 15.5333 15.9 14.55C15.9 13.85 15.7 13.2083 15.3 12.625C14.9 12.0417 14.1 11.5333 12.9 11.1C11.9 10.7667 11.2083 10.475 10.825 10.225C10.4417 9.975 10.25 9.63333 10.25 9.2C10.25 8.76667 10.4042 8.425 10.7125 8.175C11.0208 7.925 11.4667 7.8 12.05 7.8C12.5833 7.8 13 7.92917 13.3 8.1875C13.6 8.44583 13.8167 8.76667 13.95 9.15L15.55 8.5C15.3667 7.91667 15.0292 7.40833 14.5375 6.975C14.0458 6.54167 13.5 6.3 12.9 6.25V5H11.15V6.25C10.3167 6.43333 9.66667 6.8 9.2 7.35C8.73333 7.9 8.5 8.51667 8.5 9.2C8.5 9.98333 8.72917 10.6167 9.1875 11.1C9.64583 11.5833 10.3667 12 11.35 12.35C12.4 12.7333 13.1292 13.075 13.5375 13.375C13.9458 13.675 14.15 14.0667 14.15 14.55C14.15 15.1 13.9542 15.5042 13.5625 15.7625C13.1708 16.0208 12.7 16.15 12.15 16.15C11.6 16.15 11.1125 15.9792 10.6875 15.6375C10.2625 15.2958 9.95 14.7833 9.75 14.1L8.1 14.75C8.33333 15.55 8.69583 16.1958 9.1875 16.6875C9.67917 17.1792 10.3167 17.5167 11.1 17.7V19ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                    fill="#27AE60"
                />
            </svg>
        </div>
    );
};

export const GreenUserIconSVG = () => {

    return (
        <div className="svg-wrapper">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path 
                    d="M12.5 12C11.4 12 10.4583 11.6083 9.675 10.825C8.89167 10.0417 8.5 9.1 8.5 8C8.5 6.9 8.89167 5.95833 9.675 5.175C10.4583 4.39167 11.4 4 12.5 4C13.6 4 14.5417 4.39167 15.325 5.175C16.1083 5.95833 16.5 6.9 16.5 8C16.5 9.1 16.1083 10.0417 15.325 10.825C14.5417 11.6083 13.6 12 12.5 12ZM4.5 20V17.2C4.5 16.6333 4.64583 16.1125 4.9375 15.6375C5.22917 15.1625 5.61667 14.8 6.1 14.55C7.13333 14.0333 8.18333 13.6458 9.25 13.3875C10.3167 13.1292 11.4 13 12.5 13C13.6 13 14.6833 13.1292 15.75 13.3875C16.8167 13.6458 17.8667 14.0333 18.9 14.55C19.3833 14.8 19.7708 15.1625 20.0625 15.6375C20.3542 16.1125 20.5 16.6333 20.5 17.2V20H4.5Z"
                    fill="#27AE60"
                />
               
            </svg>
        </div>
    );
};

export const GreenApiIconSVG = () => {
    return (
        <div className="svg-wrapper">
            <svg
                width="25"
                height="24"
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="Icons">
                    <path
                        id="Vector"
                        d="M10.1 15.6L11.5 14.15L9.35 12L11.5 9.85L10.1 8.4L6.5 12L10.1 15.6ZM14.9 15.6L18.5 12L14.9 8.4L13.5 9.85L15.65 12L13.5 14.15L14.9 15.6ZM5.5 21C4.95 21 4.47917 20.8042 4.0875 20.4125C3.69583 20.0208 3.5 19.55 3.5 19V5C3.5 4.45 3.69583 3.97917 4.0875 3.5875C4.47917 3.19583 4.95 3 5.5 3H9.7C9.91667 2.4 10.2792 1.91667 10.7875 1.55C11.2958 1.18333 11.8667 1 12.5 1C13.1333 1 13.7042 1.18333 14.2125 1.55C14.7208 1.91667 15.0833 2.4 15.3 3H19.5C20.05 3 20.5208 3.19583 20.9125 3.5875C21.3042 3.97917 21.5 4.45 21.5 5V19C21.5 19.55 21.3042 20.0208 20.9125 20.4125C20.5208 20.8042 20.05 21 19.5 21H5.5ZM12.5 4.25C12.7167 4.25 12.8958 4.17917 13.0375 4.0375C13.1792 3.89583 13.25 3.71667 13.25 3.5C13.25 3.28333 13.1792 3.10417 13.0375 2.9625C12.8958 2.82083 12.7167 2.75 12.5 2.75C12.2833 2.75 12.1042 2.82083 11.9625 2.9625C11.8208 3.10417 11.75 3.28333 11.75 3.5C11.75 3.71667 11.8208 3.89583 11.9625 4.0375C12.1042 4.17917 12.2833 4.25 12.5 4.25Z"
                        fill="#27AE60"
                    />
                </g>
            </svg>
        </div>
    );
};

export const GreenIssueIconSVG = () => {

    return (
        <div className="svg-wrapper">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="Icons">
                    <path
                        id="Vector"
                        d="M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 13H13V7H11V13ZM8.25 21L3 15.75V8.25L8.25 3H15.75L21 8.25V15.75L15.75 21H8.25Z"
                        fill="#27AE60"
                    />
                </g>
            </svg>
        </div>
    );
};

export const GreenNotificationIconSVG = () => {

    return (
        <div className="svg-wrapper">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="Icons">
                    <path 
                        id="Vector"
			            d="M 10.5 2 L 10.5 4.1953125 C 7.9131836 4.862095 6 7.2048001 6 10 L 6 15 L 18 15 L 18 10 C 18 7.2048001 16.086816 4.862095 13.5 4.1953125 L 13.5 2 L 10.5 2 z M 4 17 L 4 19 L 10.269531 19 A 2 2 0 0 0 10 20 A 2 2 0 0 0 12 22 A 2 2 0 0 0 14 20 A 2 2 0 0 0 13.728516 19 L 20 19 L 20 17 L 4 17 z"
                        fill="#27AE60"
                    />
                </g>
            </svg>
        </div>
    );
};

export const GreenDownloadIconSVG = () => {

    return (
        <div className="svg-wrapper">
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g id="Icons">
                    <path 
                        id="Vector"
			            d="M3.33317 14.6663C2.94359 14.6663 2.61008 14.5276 2.33265 14.2502C2.05522 13.9728 1.9165 13.6393 1.9165 13.2497V4.74967C1.9165 4.36009 2.05522 4.02658 2.33265 3.74915C2.61008 3.47172 2.94359 3.33301 3.33317 3.33301H6.87484V4.74967H3.33317V13.2497H14.6665V4.74967H11.1248V3.33301H14.6665C15.0561 3.33301 15.3896 3.47172 15.667 3.74915C15.9445 4.02658 16.0832 4.36009 16.0832 4.74967V13.2497C16.0832 13.6393 15.9445 13.9728 15.667 14.2502C15.3896 14.5276 15.0561 14.6663 14.6665 14.6663H3.33317ZM8.99984 11.408L5.45817 7.86634L6.44984 6.87467L8.2915 8.71634V3.33301H9.70817V8.71634L11.5498 6.87467L12.5415 7.86634L8.99984 11.408Z"
                        fill="#27AE60"
                    />
                </g>
            </svg>
        </div>
    );
};